import { Loader } from '@payright/web-components';
import { useFetchPlanStateIfNull, useFetchStateDataIfNull, useQuery } from '../../util/hooks';
import { LoanPurposeForm } from './components/loan-purpose-form';
import { StepBody } from '../../components/step-body';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../reducers';
import LargeHeaderWithNav from '../../layouts/large-header-with-nav-layout';
import getConstants from '../../util/constants';
import { acceptLoanPurpose } from '../../reducers/plan-slice';
import { useAppStepNavigation } from '../../util/hooks/useAppStepNavigation';
import { AppThunkDispatch } from '../../util/store';
import { AlertSliceError } from '../../components/alert-slice-error';

const { REDIRECT_URL } = getConstants();

const getLoanPurpose = (
  applicationCompleteBy: string | undefined,
  purposeOfLoan: string | undefined,
  marketSegment: string | undefined,
  merchantIndustry: string | undefined
) => {
  if (applicationCompleteBy === 'Ecommerce') {
    return marketSegment || merchantIndustry;
  } else {
    return purposeOfLoan;
  }
};

export const LoanPurpose = () => {
  useFetchPlanStateIfNull();
  const query = useQuery();
  const queryParamCheckoutId = query.get('checkoutId');
  const { storeConfig, loading: authLoading } = useSelector((state: RootState) => state.auth);
  const { checkout, loading: checkoutLoading } = useSelector((state: RootState) => state.checkout);
  const dispatch = useDispatch<AppThunkDispatch>();
  const { goToStep } = useAppStepNavigation();
  const isAcceptingLoanPurpose = useSelector((state: RootState) =>
    state?.plan?.activeRequests?.includes('acceptLoanPurpose')
  );
  const {
    loading: planLoading,
    plan,
    ...planError
  } = useSelector((state: RootState) => state.plan);

  const storeName = storeConfig?.name;
  const checkoutId = checkout?.id ?? queryParamCheckoutId ?? '';
  const loanAmount = plan?.loanAmount ?? checkout?.attributes?.saleAmount ?? 0;
  const loanPurpose =
    getLoanPurpose(
      checkout?.applicationCompletedBy,
      checkout?.attributes?.purposeOfLoan,
      storeConfig?.marketSegment,
      storeConfig?.merchantIndustry
    ) ?? '';
  const redirectUrl = checkout?.attributes?.redirectUrl ?? REDIRECT_URL;
  const isLoading = checkoutLoading || authLoading || planLoading;

  useFetchStateDataIfNull(checkoutId);

  const handleContinue = async () => {
    const result = await dispatch(acceptLoanPurpose(checkoutId));
    if (result.nextStep) goToStep(result.nextStep);
  };

  if (isLoading) {
    return (
      <LargeHeaderWithNav>
        <StepBody>
          <Loader text="Fetching your plan details ..." />
        </StepBody>
      </LargeHeaderWithNav>
    );
  }

  return (
    <>
      <LargeHeaderWithNav>
        <StepBody>
          <LoanPurposeForm
            isDisabled={isLoading || isAcceptingLoanPurpose}
            isSubmitting={isAcceptingLoanPurpose}
            loanAmount={loanAmount}
            loanPurpose={loanPurpose}
            storeName={storeName as string}
            onContinue={handleContinue}
          />
          <AlertSliceError slice={planError} />
        </StepBody>
      </LargeHeaderWithNav>
    </>
  );
};
